import * as icons from '@ant-design/icons';
const iconList = {};
Object.keys(icons).forEach(k => {
    let type;
    const iconName = k.replace(/(?:fill|outline|twotone)$/i, sub => {
        type = sub;
        return '';
    });

    iconList[iconName] = iconList[iconName] || [];
    iconList[iconName].push(type);
});

export default iconList;

export const themeNames = {
    Fill: '实底',
    Outline: '描边',
    TwoTone: '双色'
};